/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserImportSkipReason } from './UserImportSkipReason';
import {
    UserImportSkipReasonFromJSON,
    UserImportSkipReasonFromJSONTyped,
    UserImportSkipReasonToJSON,
    UserImportSkipReasonToJSONTyped,
} from './UserImportSkipReason';

/**
 * Outcome of one row in a bulk import.
 * @export
 * @interface UserImportRowResult
 */
export interface UserImportRowResult {
    /**
     * Position of the row in the submitted items list
     * @type {number}
     * @memberof UserImportRowResult
     */
    index: number;
    /**
     * 
     * @type {string}
     * @memberof UserImportRowResult
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserImportRowResult
     */
    status: UserImportRowResultStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UserImportRowResult
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserImportRowResult
     */
    user_id?: string | null;
    /**
     * 
     * @type {UserImportSkipReason}
     * @memberof UserImportRowResult
     */
    reason?: UserImportSkipReason | null;
}


/**
 * @export
 */
export const UserImportRowResultStatusEnum = {
    Created: 'created',
    Skipped: 'skipped'
} as const;
export type UserImportRowResultStatusEnum = typeof UserImportRowResultStatusEnum[keyof typeof UserImportRowResultStatusEnum];


/**
 * Check if a given object implements the UserImportRowResult interface.
 */
export function instanceOfUserImportRowResult(value: object): value is UserImportRowResult {
    if (!('index' in value) || value['index'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UserImportRowResultFromJSON(json: any): UserImportRowResult {
    return UserImportRowResultFromJSONTyped(json, false);
}

export function UserImportRowResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserImportRowResult {
    if (json == null) {
        return json;
    }
    return {
        
        'index': json['index'],
        'email': json['email'],
        'status': json['status'],
        'username': json['username'] == null ? undefined : json['username'],
        'user_id': json['user_id'] == null ? undefined : json['user_id'],
        'reason': json['reason'] == null ? undefined : UserImportSkipReasonFromJSON(json['reason']),
    };
}

export function UserImportRowResultToJSON(json: any): UserImportRowResult {
    return UserImportRowResultToJSONTyped(json, false);
}

export function UserImportRowResultToJSONTyped(value?: UserImportRowResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'index': value['index'],
        'email': value['email'],
        'status': value['status'],
        'username': value['username'],
        'user_id': value['user_id'],
        'reason': UserImportSkipReasonToJSON(value['reason']),
    };
}

